/**
 * Created with IntelliJ IDEA.
 * User: tendlich
 *
 * Controller is responsible to display the extended list view in the ticketcontainer
 */

define(function (require) {
    "use strict";
    var LE = require("app");

    var OrganizeCollectionDecorator = require("decorators/organizeCollectionDecorator/OrganizeCollectionDecorator");
    var SelectableCollectionDecorator = require("decorators/SelectableCollectionDecorator");
    var TicketsCollection = require("connection-collections/ticketTab/TicketsCollection");
    var TicketModel = require("connection-models/ticketTab/TicketModel");
    var TicketsListLayout = require("connection-views/ticketTab/extendedList/TicketsListLayout");
    var TicketsGridView = require("connection-views/ticketTab/extendedList/TicketsGridView");
    var TicketsGridModel = require("connection-models/ticketTab/extendedList/TicketsGridModel");
    var TicketListComparators = require("connection-comparators/TicketListComparators");
    var TicketListExportModel = require("connection-models/ticketTab/TicketListExportModel");
    var CP_CONST = require("connection-const");
    var errorNotifier;

    var TicketTabController = {};
    LE.module('LEConnection', function (LEConnection, LE, Backbone, Marionette, $, _) {
        TicketTabController = Marionette.Controller.extend({

            referrerAction: "ticketTest",
            dataInitialized: false,

            initialize: function (options) {
                this.contentContainerChannel = options.contentContainerChannel || {vent: {}};
                this.usageTrackingChannel = options.usageTrackingChannel || {vent: {}};
                this.ticketsCollection = options.ticketsCollection || {};
                this.context = options.connectionPanelContextModel || {};
                this.isCreateCaseVisible = options.isCreateCaseVisible || false;
                this.ticketTabChannel = LEConnection.media.channel(LE.mediaCodes.connection.channels.TICKET_TAB);
            },

            show: function (tickets) {
                LEConnection.logger.debug("show", "TicketExtendedViewController:show");
                this._initData(tickets);
                this.ticketsListLayout = new TicketsListLayout({
                    collection: this.ticketsCollection,
                    actionMenuVisibility: this._getActionMenuVisibility(),
                    context: this.context
                });
                this._onTicketListLayoutRendered();
            },

            _isAllowedToExport: function () {
                //todo find out who will be allowed to make an export and then create the check for permissions, site settings and so on
                return true;
            },

            _getActionMenuVisibility: function () {
                var visibility = {};
                visibility[TicketsListLayout.ACTION_MENU_ITEMS.EXPORT] = this._isAllowedToExport();
                visibility[TicketsListLayout.ACTION_MENU_ITEMS.ADD] = this.isCreateCaseVisible;//this._isAllowedToCreateCase();
                return visibility;
            },

            _initData: function (tickets) {
                LEConnection.logger.debug("_initData", "TicketExtendedViewController:_initData");
                this.ticketsCollection.organize({currentPage: 1});
                this.listenTo(this.ticketsCollection, "change add remove reset", this._updatePagingInfo);
            },

            _bindEvents: function () {
                this.listenTo(this.ticketsListLayout, "TLL::paging:change", this._onPagingChange); //TODO better name as well as "better on"
                this.listenTo(this.ticketsListLayout, "search:initiate", this._onSearchTermChange);
                this.listenTo(this.ticketsListLayout, "filter::initiate", this._onFilterApplied);
                this.listenTo(this.ticketsListLayout, "usage::track:search", this._onSearchUsageTrack);
                this.listenTo(this.ticketsListLayout, "TicketListLayout::actionMenu:select", this._onActionMenuSelect);
            },

            _onSearchUsageTrack: function (searchEvent) {
                if (searchEvent && searchEvent.value && searchEvent.value.length > 0) {
                    this.usageTrackingChannel.vent.trigger("UsageTrackingController:track", {
                        slug: searchEvent.value,
                        usageToTrack: CP_CONST.USAGE_TO_TRACK.MYCASES.SEARCH_CASES
                    });
                }
            },
            _onPagingChange: function (currentPageNumber) {
                this.ticketsCollection.organize({currentPage: currentPageNumber});
            },
            _onSearchTermChange: function (searchEvent) {
                if (this.ticketsCollection) {
                    this.ticketsCollection.filterBySummary(searchEvent.value);
                }
            },

            _updatePagingInfo: function () {
                if (this.ticketsListLayout) {
                    this.ticketsListLayout.updatePagingInfo();
                }
            },

            _onFilterApplied: function (filterInfo) {
                if (this.ticketsCollection) {
                    this.ticketsCollection.organize(filterInfo);
                    //this.ticketsListLayout.updatePagingInfo();
                }
            },

            _onTicketListLayoutRendered: function () {
                this._bindEvents();
                this.ticketsListView = new TicketsGridView({
                    collection: this.ticketsCollection,
                    comparators: TicketListComparators,
                    model: new TicketsGridModel()//todo
                });
                this._showRegion(this.ticketsListLayout.gridRegion, this.ticketsListView);
                this._displayExtendedLayout();
            },

            _displayExtendedLayout: function () {
                this.contentContainerChannel.vent.trigger("TicketExtendedContainerController::container:displayExtendedView", this.ticketsListLayout);
            },

            _setLoader: function () {
                if (this.ticketsListLayout && this.tickets.getFetchState() === TicketsCollection.FetchState.LOADING) {
                    this.ticketsListLayout.setLoader();
                }
            },

            _showRegion: function (region, view) { //??
                if (this.ticketsListLayout.getIsRendered()) {
                    region.show(view);
                }
                else {
                    this.listenTo(this.ticketsListLayout, "render", function () {
                        region.show(view);
                    });
                }
            },

            _onActionMenuSelect: function (selectedItemId) {
                LEConnection.logger.debug("_onActionMenuSelect " + selectedItemId, "TicketExtendedListViewController:_onActionMenuSelect");
                switch (selectedItemId) {
                    case TicketsListLayout.ACTION_MENU_ITEMS.ADD:
                        this.ticketTabChannel.vent.trigger("TicketTabController::createTicket:display");
                        break;
                    case TicketsListLayout.ACTION_MENU_ITEMS.EXPORT:
                        this._exportAllCases();
                        break;
                }
            },

            _exportAllCases: function () {
                LEConnection.logger.debug("_exportAllCases", "TicketExtendedListViewController:_exportAllCases");
                var newDate = new Date();
                var year = newDate.getFullYear();
                var day = newDate.getDate();
                var month = ["Jan", "Feb", "Mar", "Apr", "May", "Jun",
                    "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"][newDate.getMonth()];
                var hours = newDate.getHours();
                var minutes = newDate.getMinutes();
                var seconds = newDate.getSeconds();
                var fileName = "CasesExport_" + year + month + day + '_' + hours + "-" + minutes + "-" + seconds;

                if (errorNotifier) {
                    errorNotifier.close();
                }
                var startNotifier = LEConnection.notifier.showInfoExtended(LE.translator.translate("LEConnection.cases.extendedView.action.exportAll.start"));
                var tempModel = new TicketListExportModel({fileName: fileName});
                tempModel.fetch({
                    success: function (model, response, options) {
                        LEConnection.logger.debug("fetch content success - file will download", "TicketExtendedContainerController:_exportAllCases");
                    },
                    error: _.bind(function (model, response, options) {
                        startNotifier.close();
                        errorNotifier = LEConnection.notifier.showErrorExtended(LE.translator.translate("LEFramework.global.export.failed"));
                        LEConnection.logger.error("TicketExtendedListViewController:_exportAllCases - export of cases failed");
                    }, this)
                });

            }

        });
    });
    return TicketTabController;
});


